var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* tslint:disable */
import './login.css';
import { Button, Checkbox, Form, Icon, Input, message, Spin } from 'antd';
import * as React from 'react';
import vertexLogo from 'src/shared/assets/images/logo.png';
import form from 'src/shared/decorators/form';
import observer from 'src/shared/decorators/observer';
import stores from 'src/stores/stores';
import authBg from '/src/shared/assets/images/auth-bg.jpg';
import firatLogo from 'src/shared/assets/images/firat-logo.png';
import malorsaLogo from 'src/shared/assets/images/malorsa.png';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    _this.loading = true;
                    stores.auth.login(values.userName, values.password, values.isPersistent).then(function (c) {
                        if (c.succeeded) {
                            location.href = '/';
                        }
                        else if (c.isLockedOut) {
                            message.error('Hesabınız geçici olarak kilitlenmiştir!');
                        }
                        else if (c.isNotAllowed) {
                            message.error('Giriş yapmaya yetkiniz bulunmamaktadır!');
                        }
                        else {
                            message.error('Kullanıcı veya parola yanlış!');
                        }
                        _this.loading = false;
                    });
                }
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        document.body.className = '';
    };
    default_1.prototype.render = function () {
        if (location.pathname === '/') {
            location.href = '/osb';
            return;
        }
        else {
            if (!(location.pathname === '/fka') && !(location.pathname === '/osb')) {
                location.href = '/404';
                return;
            }
        }
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var logo = location.pathname.startsWith('/fka') ? firatLogo : malorsaLogo;
        var brandName = location.pathname.startsWith('/fka') ? 'FIRAT KALKINMA AJANSI' : 'ELAZIĞ 2. ORGANİZE SANAYİ BÖLGESİ';
        return (React.createElement("div", { className: "auth-wrapper", style: { background: 'url(' + authBg + ') no-repeat center center' } },
            React.createElement("div", { style: { paddingTop: '10%' } },
                React.createElement(Spin, { spinning: this.loading },
                    React.createElement("div", { className: "auth-box" },
                        React.createElement("div", { className: "logo" },
                            React.createElement("div", null,
                                React.createElement("img", { src: logo, width: "120" })),
                            React.createElement("div", null,
                                React.createElement("span", null, brandName)),
                            React.createElement("div", { style: { fontStyle: 'italic', color: '#999' } }, "Ba\u015Fvuru Takip Sistemi")),
                        React.createElement("hr", null),
                        React.createElement(Form, { onSubmit: this.onSubmit },
                            React.createElement(Form.Item, { label: "Kullan\u0131c\u0131 Ad\u0131" }, getFieldDecorator('userName', {
                                rules: [{ required: true, message: 'Alan zorunlu!' }]
                            })(React.createElement(Input, { prefix: React.createElement(Icon, { type: "user", style: { color: 'rgba(0,0,0,.25)' } }) }))),
                            React.createElement(Form.Item, { label: "\u015Eifre" }, getFieldDecorator('password', {
                                rules: [{ required: true, message: 'Alan zorunlu!' }]
                            })(React.createElement(Input, { prefix: React.createElement(Icon, { type: "lock", style: { color: 'rgba(0,0,0,.25)' } }), type: "password" }))),
                            React.createElement(Form.Item, null, getFieldDecorator('isPersistent', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(React.createElement(Checkbox, null, "Beni Hat\u0131rla"))),
                            React.createElement(Button, { type: "primary", htmlType: "submit", block: true }, "Giri\u015F Yap")),
                        React.createElement("hr", null),
                        React.createElement("div", null,
                            React.createElement("img", { src: vertexLogo, width: "20" }),
                            React.createElement("a", { href: "http://www.vertexyazilim.com/", target: "_blank" }, "Vertex Yaz\u0131l\u0131m")))))));
    };
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/core/auth/Login.tsx
// module id = 1286
// module chunks = 0